<template>
  <div class="moneyCount">
    <div style="display:flex;height:32px;align-items: center;">
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='DAY'?'active':''"
        type="text"
        @click="chooseType('DAY')"
      >今日</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='MONTH'?'active':''"
        type="text"
        @click="chooseType('MONTH')"
      >本月</el-button>
      <el-button
        slot="reference"
        class="textType"
        :class="timeType==='YEAR'?'active':''"
        type="text"
        @click="chooseType('YEAR')"
      >本年</el-button>
      <el-form ref="form" :model="form" inline>
        <el-form-item label="自定义时间">
          <el-date-picker
            v-model="form.date1"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            size="small"
            style="width: 150px;"
          />
          &nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;
          <el-date-picker
            v-model="form.date2"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 150px;"
          />
        </el-form-item>
        <el-form-item style="margin-left:30px">
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="box"
      style="border:1px solid rgb(121, 121, 121);height:173px;display:flex;align-items:center;position:relative"
    >
      <div
        class="gang1"
        style="width:6px;height:109px;background:rgb(204, 204, 204);position:absolute;left:25%"
      />
      <div
        class="gang2"
        style="width:6px;height:109px;background:rgb(204, 204, 204);position:absolute;left:45%"
      />
      <div
        class="gang3"
        style="width:6px;height:109px;background:rgb(204, 204, 204);position:absolute;left:67%"
      />
      <div style="width:20%;display:flex;">
        <div>
          <i class="iconfont icon-iconset0216" style="font-size:94px" />
        </div>
        <div style="margin-top:10px;margin-left:10px">
          <div style="font-size:22px;color:#333333;margin-bottom:10px">充电度数</div>
          <span
            class="moneyNum"
            :title="detail.power"
          >{{ getFloat(detail.power) }}</span>
          <span style="font-size:14px;color:#333333;">度</span>
        </div>
      </div>
      <div style="width:16%;display:flex">
        <div>
          <img src="./../../assets/icon2.png" alt="" style="width:100px;height:97px">
        </div>
        <div style="margin-top:10px;margin-left:10px">
          <span style="font-size:22px;color:#333333;margin-bottom:10px;display:block">实收电费</span>
          <span
            class="moneyNum"
            :title="detail.elecMoney"
          >{{ getFixed2(detail.elecMoney) }}</span>
          <span style="font-size:14px;color:#333333;">元</span>
        </div>
      </div>
      <div style="width:16%;display:flex">
        <div>
          <img src="./../../assets/icon3.png" alt="" style="width:100px;height:97px">
        </div>
        <div style="margin-top:10px;margin-left:10px">
          <span style="font-size:22px;color:#333333;margin-bottom:10px;display:block">实收服务费</span>
          <span
            class="moneyNum"
            :title="detail.serviceMoney"
          >{{ getFixed2(detail.serviceMoney) }}</span>
          <span style="font-size:14px;color:#333333;">元</span>
        </div>
      </div>
      <div style="width:30%;display:flex">
        <div>
          <img src="./../../assets/icon4.png" alt="" style="width:100px;height:97px">
        </div>
        <div>
          <div style="margin-left:10px">
            <span
              style="font-size:22px;color:#333333;margin-bottom:15px;display:inline-block;margin-left:15px;margin-right:40px"
            >运营商分润</span>
            <span
              class="moneyNum"
              :title="detail.operatorProfit"
            >{{ getFloat(detail.operatorProfit) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
          <div style="margin-left:10px">
            <span
              style="font-size:22px;color:#333333;display:inline-block;margin-left:15px;margin-right:40px"
            >其他方分润</span>
            <span
              class="moneyNum"
              :title="detail.otherProfit"
            >{{ getFloat(detail.otherProfit) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
      </div>
    </div>
    <template>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column type="index" align="center" width="50" label="序号" />
        <el-table-column label="运营商名称" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goToDetail(scope.row.orgId)">{{ scope.row.orgName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.power) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收电费" align="center">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.elecMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收服务费" align="center">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运营商分润金额" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.operatorProfit) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="其他方分润金额" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.otherProfit) }}</span>
          </template>
        </el-table-column>

      </el-table>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Fenrunhuizong',
  components: {},
  data() {
    return {
      form: {
        date1: '',
        date2: ''
      },
      timeType: 'DAY',
      tableData: [],
      detail: {}
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getPageData()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    onSubmit() {
      this.getPageData()
    },

    getPageData(val) {
      const data = {
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/index',
        data: data,
        method: 'get',
        callback: resp => {
          this.detail = resp.summary
          if (resp.list.length > 0) {
            this.tableData = resp.list
          } else {
            this.tableData = []
          }
        }
      })
    },
    chooseType(val) {
      this.timeType = val
      this.form = {
        date1: '',
        date2: ''
      }
    },
    goToDetail(id) {
      this.$router.push({
        path: './moneyDetail',
        query: { id: id }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" scoped>
    .moneyCount {
        .textType {
            color: #C0C4CC;
            width: 100px;

            &.active {
                color: #409eff;
                border-bottom: 2px solid #409eff;
            }
        }

        .box {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            margin-bottom: 40px;
            padding: 0 20px;

            .moneyNum {
                font-size: 31px;
                color: #1890FF;
                font-weight: 500;
                max-width: calc(100% - 20px);
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            div {
                .iconfont {
                    font-size: 28px;
                    font-weight: 600;
                }

                .icon-iconset0216 {
                    color: #32F83E;
                }

                .icon-lirunbiao {
                    color: #F2E743;
                }

                .icon-yingshouzhangkuan {
                    color: #F2E743;
                    font-size: 24px;
                }

                .icon-qianbao {
                    color: #409eff;
                }

                .icon-qianbao1 {
                    color: #409eff;
                    font-size: 24px;
                }

                .icon-yingshouzhangkuan {
                    font-size: 26px;
                }

                .icon-shishoufeiyong {
                    font-size: 30px;
                }
            }
        }

        .el-form {
            .el-form-item {
                margin-bottom: 0 !important;
            }

            display: flex !important;

            .el-input__prefix {
                line-height: 32px !important;
            }

            .el-form-item__content {
                margin-left: 0 !important;
                line-height: 32px !important;
            }

            .el-date-editor {
                width: 220px !important;
            }

            .el-col-2 {
                width: 30px;
                text-align: center;
                line-height: 32px;
            }

            .el-col-11 {
                width: 220px !important;
                line-height: 32px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/moneyCount.vue